import { render, staticRenderFns } from "./detail_nav.vue?vue&type=template&id=f4ccd570&"
import script from "./detail_nav.vue?vue&type=script&lang=js&"
export * from "./detail_nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports